import { render } from "./Draggable.vue?vue&type=template&id=683fa95a&ts=true"
import script from "./Draggable.vue?vue&type=script&lang=ts"
export * from "./Draggable.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Users\\orson\\coding\\thelounge\\thelounge\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"client/components/Draggable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "683fa95a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('683fa95a', __exports__)) {
    api.reload('683fa95a', __exports__)
  }
  
  module.hot.accept("./Draggable.vue?vue&type=template&id=683fa95a&ts=true", () => {
    api.rerender('683fa95a', render)
  })

}


export default __exports__